import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_LAST_SUBSCRIPTIONS,
  REMOVE_LAST_SUBSCRIPTIONS,
  RECEIVE_LAST_VALUES,
  VARIABLES_IMPORTED_AT,
  SET_VARIABLES_LAST_POLLING,
  VARIABLE_IMPORT_ERRORS,
} from './actions';

const initialState = {
  variablesLastPolling: {},
  lastSubscriptions: {},
  lastData: {},
  importErrors: [],
  variablesImportedAt: 0,
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_LAST_SUBSCRIPTIONS: {
      const { variableIds, panelId } = action;
      return {
        ...state,
        lastSubscriptions: {
          ...state.lastSubscriptions,
          ...variableIds.reduce((acc, variableId) => {
            acc[variableId] = {
              ...(state.lastSubscriptions[variableId] || {}),
              [panelId]: true,
            };
            return acc;
          }, {}),
        },
      };
    }
    case REMOVE_LAST_SUBSCRIPTIONS: {
      const { variableIds, panelId } = action;
      return {
        ...state,
        lastSubscriptions: {
          ...state.lastSubscriptions,
          ...variableIds.reduce((acc, variableId) => {
            const updated = { ...state.lastSubscriptions[variableId] };
            delete updated[panelId];
            acc[variableId] = updated;
            return acc;
          }, {}),
        },
      };
    }
    case SET_VARIABLES_LAST_POLLING: {
      return {
        ...state,
        variablesLastPolling: {
          ...state.variablesPolling,
          ...action.data,
        },
      };
    }
    case RECEIVE_LAST_VALUES: {
      const newLastData = { ...state.lastData };

      action.values.forEach((value) => {
        newLastData[value.variable] = value.value;
      });

      return { ...state, lastData: newLastData };
    }
    case VARIABLES_IMPORTED_AT: {
      return {
        ...state,
        variablesImportedAt: action.variablesImportedAt,
      };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        variablesLastPolling: {},
        lastSubscriptions: {},
        lastData: {},
        importErrors: [],
        variablesImportedAt: 0,
      };
    }
    case VARIABLE_IMPORT_ERRORS: {
      return { ...state, importErrors: action.errors };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
